import Select from "react-select";

const TrialBalanceBranchInput = ({
    branches,
    selectedBranch,
    onChange,
    loadingBranches,
}) => {
    const options = branches.map((branch) => ({
        label: branch.name,
        value: branch.id,
    }));

    const getCurrentValue = () => {
        if (!selectedBranch) return null;
        return options.find((option) => option.value === selectedBranch) ?? null;
    };

    const handleChange = (selectedOption) => {
        onChange(selectedOption ? selectedOption.value : null);
    };

    return (
        <div className="w-[320px]">
            {loadingBranches ? (
                <p className="text-center text-sm text-[#5F5E5A]">
                    Loading branches...
                </p>
            ) : branches.length === 0 ? (
                <p className="text-center text-sm text-red-500">
                    No branches available
                </p>
            ) : (
                <Select
                    value={getCurrentValue()}
                    isSearchable
                    placeholder="Select Branch"
                    onChange={handleChange}
                    options={options}
                    isLoading={loadingBranches}
                    className="text-sm"
                    classNamePrefix="branch-select"
                    styles={{
                        control: (base, state) => ({
                            ...base,
                            minHeight: "40px",
                            borderRadius: "8px",
                            borderColor: state.isFocused
                                ? "#BDBBB2"
                                : "#D3D1C7",
                            boxShadow: "none",
                            backgroundColor: "#FFFFFF",
                            cursor: "pointer",
                            fontSize: "14px",
                            "&:hover": {
                                borderColor: "#BDBBB2",
                            },
                        }),

                        valueContainer: (base) => ({
                            ...base,
                            padding: "0 10px",
                        }),

                        input: (base) => ({
                            ...base,
                            margin: "0px",
                            padding: "0px",
                            color: "#2C2C2A",
                            fontSize: "14px",
                        }),

                        placeholder: (base) => ({
                            ...base,
                            color: "#9A978F",
                            fontSize: "14px",
                        }),

                        singleValue: (base) => ({
                            ...base,
                            color: "#2C2C2A",
                            fontSize: "14px",
                            fontWeight: 500,
                        }),

                        menu: (base) => ({
                            ...base,
                            borderRadius: "10px",
                            overflow: "hidden",
                            marginTop: "6px",
                            border: "1px solid #E5E2DC",
                            boxShadow:
                                "0 4px 14px rgba(0,0,0,0.06)",
                            zIndex: 30,
                        }),

                        menuList: (base) => ({
                            ...base,
                            padding: "6px",
                        }),

                        option: (base, state) => ({
                            ...base,
                            fontSize: "13px",
                            borderRadius: "7px",
                            padding: "10px 12px",
                            backgroundColor: state.isSelected
                                ? "#ECEAE3"
                                : state.isFocused
                                    ? "#F7F7F5"
                                    : "#FFFFFF",
                            color: "#2C2C2A",
                            cursor: "pointer",
                            transition: "all 0.12s ease",
                            fontWeight: state.isSelected
                                ? 500
                                : 400,
                        }),

                        clearIndicator: (base) => ({
                            ...base,
                            padding: "6px",
                            color: "#888780",
                            cursor: "pointer",
                            "&:hover": {
                                color: "#2C2C2A",
                            },
                        }),

                        dropdownIndicator: (base, state) => ({
                            ...base,
                            padding: "6px",
                            color: state.isFocused
                                ? "#2C2C2A"
                                : "#888780",
                            transition: "0.15s ease",
                            cursor: "pointer",
                        }),

                        indicatorSeparator: () => ({
                            display: "none",
                        }),

                        noOptionsMessage: (base) => ({
                            ...base,
                            fontSize: "13px",
                            color: "#888780",
                            padding: "10px",
                        }),

                        loadingMessage: (base) => ({
                            ...base,
                            fontSize: "13px",
                            color: "#888780",
                            padding: "10px",
                        }),
                    }}
                />
            )}
        </div>
    );
};

export default TrialBalanceBranchInput;